/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetShippingRatesRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetShippingRatesResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getShippingRates = (request: GetShippingRatesRequest, options?: CashRequestOptions) => post<GetShippingRatesRequest, GetShippingRatesResponse>("/2.0/cash/get-shipping-rates", request, {...options, rejectOnError: true })